module.exports = "/_next/static/images/derik-jones-1e7692ca2d5031e093461b7969b81700.jpg";